import { render, staticRenderFns } from "./login.vue?vue&type=template&id=5d8045ce&scoped=true&"
import script from "./login.vue?vue&type=script&lang=js&"
export * from "./login.vue?vue&type=script&lang=js&"
import style0 from "./login.css?vue&type=style&index=0&id=5d8045ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8045ce",
  null
  
)

export default component.exports